import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const { userInfo } = useSelector((state) => state.auth); // adjust if your slice name is different

  return userInfo ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;